export function base64toUint8Array(base64str: string): Uint8Array {
  return Uint8Array.fromBase64(base64str);
}
